export default {
  LOGO: "logo",
  VIDEO_TILE: "video_tile",
  PRE_ROLL: "pre_roll",
};
